import { Http, Response, Headers, RequestOptions } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

export abstract class ParentBaseApiService<T, R> {

  constructor(protected http: Http) { }

  /**
   * Load the base service url by configuration
   */
  public abstract getServiceUrl(): string | null;

  /**
   * Find an object by its identifier
   * @param id the object identifier
   * @returns gets the object found
   */
  public findById(id: any, properties: any = null): Observable<R|T>  {
    return this.http.get(this.getServiceUrl() + '/' + id).map(this.extractData);
  }

  /**
   * Find all the elements
   * @returns gets the list of objects found
   */
  public findAll(properties: any = null): Observable<R[]|T[]> | null {
    const serviceUrl = this.getServiceUrl();
    if (serviceUrl != null) {
      let options = new RequestOptions();
      options.params = properties;
      return this.http.get(serviceUrl, options).map(this.extractData);
    }
    return null;
  }

  /**
   * Delete an object by its identifier field
   * @param id the object identifier
   * @returns gets the response
   */
  public delete(id: any): Observable<Response> {
    return this.http.delete(this.getServiceUrl() + '/' + id);
  }

  /**
   * Insert the data
   * @param data the object containing the data to be inserted
   * @returns gets the response
   */
  public insert(data: T): Observable<Response> | null {
    const serviceUrl = this.getServiceUrl();
    if (serviceUrl != null) {
      return this.http.post(serviceUrl, JSON.stringify(data));
    }
    return null;
  }

  /**
   * Updadte specific object into DB
   * @param fieldId the name of the field that identify the object
   * @param data the object to be updated
   * @returns gets the response
   */
  public update(fieldId: string, data: any): Observable<Response> {
    return this.http.put(this.getServiceUrl() + '/' + data[fieldId], JSON.stringify(data));
  }

  /**
   * Extract data that arrives from the response
   * @param res the response
   */
  protected extractData(res: Response) {
    const body = res.json() || {};
    return body.data || body;
  }
}
